import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DockOverviewFacade } from './dock-overview.facade';
import { DockItemFacade } from '../dock-item.facade';
import { switchMap } from 'rxjs/operators';
import { checkStoreState, setInitialStoreState } from '../../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class DockOverviewGuard {
  constructor(private dockItemFacade: DockItemFacade, private dockOverviewFacade: DockOverviewFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.dockItemFacade.dockId$.pipe(
      switchMap((dockId: number) => {
        return checkStoreState(this.dockOverviewFacade, dockId);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.dockOverviewFacade);
  }
}
